import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PagarCuotaMonedas from "../../../components/Pagar/PagarCuotaMonedas/PagarCuotaMonedas.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../api";
import apiFunctions from "../../../api/functions.js"
import { Monedas } from '../../Monedas/Monedas/constants.js';
import { formatCurrency } from '../../../functions/functions';

class ModalCuotas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nroCuota: '',
            moneda: null,
            monto: 0,
            vencimiento: null,
            pago: 0,
            fechaPago: null,
            esEspecial: false,
            interes: 0,
            montoActualizado: 0,
            estado: 'IMPAGA',

            montos_pagados: [],
            caja_id: null,
        }
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['PAGAR', 'DETAIL']).isRequired,
        onClose: PropTypes.func,
        missingIdMessage: PropTypes.string,
    }

    resetForm() {
        this.setState({
            nroCuota: '',
            moneda: null,
            monto: 0,
            vencimiento: null,
            pago: 0,
            fechaPago: null,
            esEspecial: false,
            interes: 0,
            montoActualizado: 0,
            estado: 'IMPAGA',

            montos_pagados: [],
            caja_id: null,
        });
    }

    getData() {
        const { caja_id, montos_pagados } = this.state;
        return {
            caja_id: caja_id,
            montos_pagados: montos_pagados,
        };
    }

    setData(data) {
        this.setState({
            id: data.id,
            nroCuota: data.nroCuota,
            moneda: data.moneda,
            monto: data.monto,
            vencimiento: moment(data.vencimiento),
            pago: data.pago,
            fechaPago: data.fechaPago,
            esEspecial: data.esEspecial,
            interes: data.interes,
            montoActualizado: data.montoActualizado,
            estado: data.estado,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    setErrors(errors) {
        this.setState({ errors });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    getUltimaCuota = () => {
        const servicioId = this.props.id ? this.props.id() : null;

        if (servicioId) {
            const parameters = {
                sort: ['vencimiento'],
                filters: ['paga=0', 'fechaPago[isnull]=0'],
                pageSize: 1,
            }

            apiFunctions.get(api.servicios.cuota, servicioId, null, parameters, (response) => {
                if (response.data.length > 0) {
                    this.setData(response.data[0]);
                }
            });
        }

        apiFunctions.get(api.caja.usuarioCaja, null, null, null, (response) => {
            if(response && response.data && response.data.caja_id){
                this.setState({caja_id: response.data.caja_id});
            }
        });
    }

    onValidation = () => {
        const { caja_id } = this.state;
        let error = {};
        let validate = true;

        if (caja_id==null){
            error.caja_id= [{code: "required", detail: "Seleccione una caja"}];
            validate = false;
        }

        this.setState({
            errors: error,
        })

        return validate;
    }

    getMonedaSimbolo = () => {
        const { moneda } = this.state;
        return moneda ? moneda.simbolo : ""
    }

    updateMontosPagados = (montos_pagados) => {
        this.setState({
            montos_pagados: montos_pagados
        })
    }

    onClose(){
        if (this.props.onClose){ // Ejecutar funcion de cerrar del componente padre si es que existe
            this.props.onClose();
        }

        this.resetForm();
    }

    render() {
        const { action, missingIdMessage } = this.props;
        const {
            id,
            nroCuota,
            moneda,
            montoActualizado
        } = this.state;
        const servicioId = this.props.id ? this.props.id() : null;
        const reciboUrl = api.servicios.recibo.replace('$id_loteo', servicioId)+ id + '/'
        const missingServicioIdMessage = missingIdMessage ? missingIdMessage : "Debe seleccionar una fila."
        const isEnDolares = moneda ? moneda.id == Monedas.DOLARES : false;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

        return (
            <ParadigmaModal
                submitUrl={api.servicios.cuota.replace('$id', servicioId)}
                submitType="PATCH"
                id={() => servicioId ? id : false}

                onOpen={this.getUltimaCuota}
                onValidation={() => this.onValidation()}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.onClose()}
                onPreSubmit={() => this.getData()}

                title="Pagar Última Cuota"

                showConfirmationMessages={true}
                successMessage={
                    <span>
                        La cuota ha sido pagada con éxito.
                        <a className="ui-btn-primary mt-3" href={reciboUrl} target="_blank">Abrir Recibo</a>
                    </span>
                }
                missingIdMessage={missingServicioIdMessage}

                buttonTitle="Pagar Última Cuota"
                buttonIcon="fa fa-dollar fa-lg"
                buttonClass="btn-success"
                saveButton={true}
                saveButtonLabel="Pagar cuota"
                closeButton={true}
                cancelButtonLabel="Cancelar"
                className="ui-paradigma-modal ui-paradigma-modal-wide"

                initOpen={this.props.initOpen || false} // Si se pasa esta prop en true se abre el modal sin necesidad de presionar el boton que abre el modal.
            >

                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la cuota</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Nro."}
                            maxLength={30}
                            value={nroCuota ? nroCuota : 'E'}
                            onChange={e => this.onChangeField('nroCuota', e.target.value)}
                            error={() => this.getError('nroCuota')}
                        />
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Tipo"}
                            value={this.state.esEspecial ? 'Especial' : 'Común'}
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Vencimiento"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={true}
                                    value={this.state.vencimiento}
                                    onChange={e => this.onChangeField('vencimiento', e.target.value)}
                                    error={() => this.getError('vencimiento')}
                                />
                            }
                        />
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Estado"}
                            inputComponent={
                                (() => {
                                    switch (this.state.estado) {
                                        case 'VENCIDA': return <div className="ui-status-pill is-danger">Vencida</div>;
                                        case 'PAGA': return <div className="ui-status-pill is-success">Paga</div>;
                                        case 'IMPAGA': return <div className="ui-status-pill is-warning">Impaga</div>;
                                        default: return null;
                                    }
                                })()
                            }
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos del pago</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Monto"}
                            error={() => this.getError('monto')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={true}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(this.state.monto)}
                                    onChange={data => this.onChangeField('monto', data)}
                                />
                            }
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Interés"}
                            error={() => this.getError('interes')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={true}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(this.state.interes)}
                                    onChange={data => this.onChangeField('interes', data)}
                                />
                            }
                        />

                        {(action == "PAGAR") &&
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Caja"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    // disabled={vars.disabled}
                                    url={api.caja.caja}
                                    parameters={{
                                        sort:['nombre'],
                                        paginationEnabled:false,
                                    }}
                                    value={this.state.caja_id}
                                    onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                                />
                            }
                            error={() => this.getError('caja_id')}
                        />}

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Total"}
                            error={() => this.getError('montoActualizado')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={true}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(this.state.montoActualizado)}
                                    onChange={data => this.onChangeField('montoActualizado', data)}
                                />
                            }
                        />
                    </div>
                </section>

                    {moneda && (action === "PAGAR") &&
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Pagar con otra moneda</p>
                            <div className="ui-payment-currency-panel">
                                <PagarCuotaMonedas
                                    montoAPagar={montoActualizado}
                                    monedaCuota={moneda}
                                    updateMontosPagados={this.updateMontosPagados}
                                />
                            </div>
                        </section>
                    }
            </ParadigmaModal>
        );
    }
}

export default ModalCuotas;



// WEBPACK FOOTER //
// ./src/views/Servicios/Cobros/ModalCuotas.js